import { useEffect, useRef, useState } from "react";
import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";
import { Smartphone } from "lucide-react";

// M-Pesa (via Paystack) top-up for Kadana's OWN credits — a second rail alongside Stripe/card.
// STK push, then poll our local status which the charge.success webhook updates. Hidden until the
// Kadana Paystack merchant account (KES) is live.
export function MpesaTopUp({ orgId, credits = 100 }) {
  const [cfg, setCfg] = useState(null);
  const [phone, setPhone] = useState("");
  const [busy, setBusy] = useState(false);
  const [state, setState] = useState(null); // {status, message, amount_kes}
  const poll = useRef(null);

  useEffect(() => {
    api.get("/billing/paystack/config").then((r) => setCfg(r.data)).catch(() => setCfg({ mpesa_enabled: false }));
    return () => { if (poll.current) clearInterval(poll.current); };
  }, []);

  if (!cfg || !cfg.mpesa_enabled) return null;

  const startPolling = (reference) => {
    let tries = 0;
    poll.current = setInterval(async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/billing/paystack/orgs/${orgId}/mpesa/status/${reference}`);
        setState(data);
        if (data.status === "success" || data.status === "held_review" || tries > 30) {
          clearInterval(poll.current);
          setBusy(false);
          if (data.status === "success") toast.success(data.message);
        }
      } catch { /* keep polling */ }
    }, 3000);
  };

  const pay = async () => {
    if (!phone.trim()) { toast.error("Enter your M-Pesa phone number"); return; }
    setBusy(true); setState(null);
    try {
      const { data } = await api.post(`/billing/paystack/orgs/${orgId}/mpesa/charge`, { credits, phone });
      setState({ status: "pending", message: data.display_message, amount_kes: data.amount_kes });
      toast.info("STK push sent — approve it on your phone");
      startPolling(data.reference);
    } catch (e) {
      toast.error(errMsg(e));
      setBusy(false);
    }
  };

  return (
    <div data-testid="mpesa-topup" style={{ marginTop: 12 }}>
      <div className="k-muted" style={{ fontSize: 11, marginBottom: 6, display: "flex", alignItems: "center", gap: 6 }}>
        <Smartphone size={13} /> or pay in KES with M-Pesa
      </div>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        <input className="k-control" data-testid="mpesa-phone" value={phone} disabled={busy}
          onChange={(e) => setPhone(e.target.value)} placeholder="07XX XXX XXX"
          style={{ flex: 1, minWidth: 160, fontSize: 13 }} />
        <button className="k-btn k-btn-ghost" data-testid="mpesa-pay" onClick={pay} disabled={busy}
          style={{ whiteSpace: "nowrap" }}>
          {busy ? "Waiting…" : `Pay with M-Pesa · ${credits} credits`}
        </button>
      </div>
      {state ? (
        <p className="k-muted" data-testid="mpesa-status" style={{ fontSize: 12, marginTop: 8 }}>
          {state.amount_kes ? `KES ${state.amount_kes} · ` : ""}{state.message}
        </p>
      ) : null}
    </div>
  );
}
